import React from "react";
import { Navigate, Outlet } from "react-router-dom";
import { jwtDecode } from "jwt-decode";

function ProtectedRouter() {
  const userInfo = JSON.parse(localStorage.getItem("userInfo") || "{}");
 
  if (!userInfo?.jwtToken) {
    return <Navigate to="/login" replace />;
  }

  try {
    const decoded = jwtDecode(userInfo.jwtToken);
    const now = Date.now() / 1000;

    if (decoded.exp < now) {
      console.warn("⚠️ Token expired, logging out");
      clearAuthState();
      return <Navigate to="/login" replace />;
    }

    if (decoded.exp - now < 300) {
      console.warn("⚠️ Token expiring soon");
    }
  } catch (err) {
    console.error("❌ Auth check failed:", err);
    clearAuthState();
    return <Navigate to="/login" replace />;
  }

  return <Outlet />;
}

function clearAuthState() {
  localStorage.removeItem("userInfo");
}

export { ProtectedRouter };